module.exports = __webpack_public_path__ + "static/media/correct2.3dbce2dc.svg";